<template src="../templates/searchJobDialog.html"></template>
<script>
    import JobsCollection from "../collections/jobsCollection";
    import SearchModel from "../models/searchBookingModel";
    import moment from 'moment';

    export default {
        name: 'SearchJobDialog',
        data() {
            return {
                jobsCollection: new JobsCollection(),
                jobsData: [],
                jobsDataArray: [],
                searchModel: new SearchModel(),
                search: '',
                message: ""
            }
        },
        methods: {
            formatDate(value, event) {
                return moment(value.serviceDate).format('D MMM YYYY')
            },
            loadJobs: function () {
                this.message = "";
                let localThis = this;
                this.searchModel.validate().then(response => {
                    let errorExists = false;
                    for (let item in response) {
                        if (item != null) {
                            errorExists = true;
                            break;
                        }
                    }
                    if (!errorExists) {
                        this.jobsCollection = new JobsCollection();
                        let url = localThis.getJobsUrl();
                        this.$http.get(url, {
                            headers: {"Bearer": localStorage.getItem("jwt")}
                        }).then(function (response) {
                            localThis.jobsData = response.data;
                        }).catch(function (error) {
                            console.log(error);
                        });
                    }
                }).catch(function (error) {
                    console.error(error);
                });
            },
            getJobsUrl() {

                let search = (this.searchModel.search !== null && this.searchModel.search !== "") ? this.searchModel.search : "null";
                return this.$localApiURL + "job/" + search;
            },
            created() {
                this.message = "";
            },
            accept() {
                let parent = this.$parent.$parent;
                if (this.jobsData.length === 1) {
                    parent.currentRow = this.jobsData[0];
                    parent.previousFormVisible = false;
                    parent.chooseRecord();
                }
                else
                    this.message = "You must select a record";
            },
            cancel() {
                let parent = this.$parent.$parent;
                parent.previousFormVisible = false;

            }

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/SearchJobDialog.vue